<template>
  <div>
    <!-- <div class="box mr-5">
      <el-select
        v-model="select"
        clearable
        placeholder="Todos"
        size="mini"
        @change="Filtropordepartamento"
        class="selector"
        default-first-option
      >
        <el-option key="1" label="Vendedores" value="32"></el-option>
        <el-option key="2" label="Servicios al Cliente" value="47"></el-option>
      </el-select>
      <el-select
        v-model="sellerSelected"
        filterable
        clearable
        size="mini"
        placeholder="Vendedor"
        @change="hanldeSelection"
        style="width: 150px"
      >
        <el-option
          v-for="(item, index) in customer_seller"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div> -->

    <el-row>
      <RabbeyTable3
        v-loading="detailTableLoading"
        :columns="columns"
        :data="items"
        style="margin: 20px"
      />
    </el-row>

    <el-drawer
      :title="Titulo"
      :visible="openDetail"
      size="60%"
      :before-close="CloseTransactionDetail"
    >
      <el-row style="margin-top: 20px">
        <el-form label-position="top">
          <el-col :span="11" style="margin-left: 20px">
            <el-form-item label="Mes">
              <el-input v-model="Month" disabled style="width: 300px" />
            </el-form-item>
          </el-col>
          <el-col :span="11" style="margin-left: 20px" v-if="ShowIndex">
            <label> Total Ganada{{ this.Ganada }}</label>
          </el-col>
          <el-col :span="11" style="margin-left: 20px" v-if="ShowIndex">
            <label>Total Perdidas: {{ this.perdida }}</label>
          </el-col>
          <el-col :span="11" style="margin-left: 20px" v-if="ShowIndex">
            <el-tag :type="this.getTagType" style="font-size: 25px"
              >{{ total }}%</el-tag
            >
          </el-col>
        </el-form>
      </el-row>

      <BusinessChart
        ref="detailChart2"
        :DetailParams="DetailData"
        Titulo="Titulo"
        Url="/api/deals/BusinessDetailsChartSuper"
      />

      <rabbey-table-3
        :loading="DrawerLoading"
        :data="itemsDetails"
        :columns="SalesColumns"
        style="margin: 20px"
      />
    </el-drawer>
  </div>
</template>

<script>
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import InteractionDetailsHyperLink from "@/components/functionals/InteractionDetailsHyperLink.vue";
import BusinessChart from "@/views/Charts/BusinessChart.vue";
// import ContactWithoutCallingSales from "../kpi/ContactWithoutCallingSales.vue";
// import CustomerServiceSellerSelector from "@/components/Company/CustomerServiceSelector.vue";
// import { columnsLinesOrderBuy } from "../../projects/ColumnsOrdersBuy/columns";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import DatetimeFormatterColor from "@/components/functionals/DatetimeFormatterColor.vue";
import InteractionTypeTagFormatter from "@/components/functionals/InteractionTypeTagFormatter.vue";

export default {
  name: "Deal-Business-Report",
  props: {
    year: Number,
    customers_service_seller_filter2: Number
  },
  data() {
    return {
      Ganada: 0,
      perdida: 0,
      Titulo: "",
      total: 0,
      sellerSelected: null,

      customer_seller: [],
      // customers_service_seller_filter2: 0,
      tabMetas: true,
      ShowIndex: false,
      Month: "",
      SalesColumns: [],
      PhasesId: 0,
      columns: [
        {
          prop: "Titulo",
          label: "Titulo",
          minWidth: 260
        },
        {
          prop: "january",
          label: "Enero",
          formatter: InteractionDetailsHyperLink,
          key: 1,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "february",
          label: "Febrero",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "march",
          label: "Marzo",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "april",
          label: "Abril",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "may",
          label: "Mayo",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "june",
          label: "Junio",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "july",
          label: "Julio",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "august",
          label: "Agosto",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "september",
          label: "Septiembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "october",
          label: "Octubre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "november",
          label: "Noviembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "december",
          label: "Diciembre",
          formatter: InteractionDetailsHyperLink,
          attrs: {
            openDrawer: this.OpenSalesDitails
          }
        },
        {
          prop: "Totales",
          label: "Total"
        }
      ],
      detailTableLoading: false,
      DrawerLoading: false,
      Company: "TB",
      items: [],
      deparmentId: 32,
      SalesCode: 0,
      columnsProspectos: [
        {
          prop: "ContactCode",
          label: "Codigo Prospecto",
          minWidth: 150
        },
        {
          prop: "CompanyName",
          label: "Empresa",
          width: 250
        },
        {
          prop: "ContactAddress",
          label: "Direccion",
          minWidth: 300
        },
        {
          prop: "City",
          label: "Ciudad",
          width: 200
        },

        {
          prop: "CreatorName",
          label: "Creador",
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "ImageCreator"
          },
          minWidth: 220,
          sortable: true,
          fix: true
        }
      ],
      itemsDetails: [],
      openDetail: false,
      Business: [
        {
          PersonName: ""
        },
        {
          Month: ""
        }
      ],
      ColumnDetailsNegociaciones: [
        {
          prop: "NameDeals",
          label: "Negociacion",
          minWidth: 260
        },
        {
          prop: "Description",
          label: "Descripcion Negociacion",
          minWidth: 260
        },
        {
          prop: "ContacName",
          label: "Contacto",
          minWidth: 260
        },
        {
          prop: "SellerName",
          label: "Vendedor",
          minWidth: 200,
          // fixed: true
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SellerImage"
          }
        },
        {
          prop: "CreatorName",
          label: "Creador",
          minWidth: 200,
          // fixed: true
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "ImageCreator"
          }
        },
        {
          prop: "Stage",
          label: "Etapa",
          minWidth: 260
        },
        {
          prop: "Quantity",
          label: "Cantidad",
          minWidth: 260
        },
        {
          prop: "Amount",
          label: "Monto",
          minWidth: 260
        },
        {
          prop: "CreatedAt",
          label: "Fecha de creacion",
          minWidth: 260
        }
      ],
      ColumnsPresentaciOn: [
        {
          prop: "DealsId",
          label: "Id"
        },

        {
          prop: "Negociacion",
          label: "Negociacion"
        },
        {
          prop: "SellerName",
          label: "Vendedor",
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SellerImage"
          }
        },

        {
          prop: "CreatorName",
          label: "Creador",
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "ImageCreator"
          }
        },
        {
          prop: "Quantity",
          label: "Cantidad"
        },

        {
          prop: "Amount",
          label: "Monto"
        },

        {
          prop: "ContactName",
          label: "Contacto"
        },

        {
          prop: "SupportSellerName",
          label: "Soporte de Venta",
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "ImageSupportSeller"
          }
        },

        {
          prop: "CustomerServiceName",
          label: "Servicio al Cliente",
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "CustomerServiceImage"
          }
        }
      ],
      ColumnsCotizacion: [
        {
          prop: "ContactCode",
          label: "Id"
        },

        {
          prop: "CompanyName",
          label: "Empresa"
        },

        {
          prop: "Quantity",
          label: "Cantidad"
        },

        {
          prop: "Amount",
          label: "Monto"
        },

        {
          prop: "CompanyName",
          label: "Contacto"
        },
        {
          prop: "SellerName",
          label: "Vendedor",
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SellerImage"
          }
        }
      ],
      agendas: [
        {
          prop: "AppoimentId",
          label: "Numero",
          minWidth: 100
          // fixed: true
        },
        {
          prop: "AppoimentTitle",
          label: "Titulo",
          minWidth: 250
          // fixed: true
        },
        {
          prop: "Description",
          label: "Descripcion",
          minWidth: 250
          // fixed: true
        },
        {
          prop: "ProspectName",
          label: "Prospecto",
          minWidth: 250
          // fixed: true
        },

        {
          prop: "SellerName",
          label: "Vendedor",
          minWidth: 200,
          // fixed: true
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SellerImage"
          }
        },
        {
          prop: "CreatorName",
          label: "Creador",
          minWidth: 200,
          // fixed: true
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "ImageCreator"
          }
        },
        {
          prop: "StarDate",
          label: "Fecha inicio",
          minWidth: 150,
          formatter: DatetimeFormatter,
          sortable: true
          // fixed: true
        },
        {
          prop: "EndDate",
          label: "Fecha fin",
          minWidth: 150,
          formatter: DatetimeFormatter,
          sortable: true
          // fixed: true
        },
        {
          prop: "Amount",
          label: "Monto",
          minWidth: 100
          // formatter: InteractionTypeTagFormatter
          // fixed: true
        }
      ],
      interacciones: [
        {
          prop: "Date",
          label: "Fecha",
          minWidth: 100,
          formatter: DatetimeFormatter,
          sortable: true
          // fixed: true
        },
        {
          prop: "Date",
          label: "Hora",
          minWidth: 100,
          formatter: DatetimeFormatterColor,
          sortable: true
          // fixed: true
        },
        {
          prop: "TipoDescripcion",
          label: "Tipo",
          minWidth: 100,
          formatter: InteractionTypeTagFormatter
          // fixed: true
        },
        {
          prop: "ClientName",
          label: "Cliente",
          minWidth: 250
          // fixed: true
        },
        {
          prop: "SellerName",
          label: "Vendedor",
          minWidth: 200,
          // fixed: true
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SellerImage"
          }
        },
        {
          prop: "CreatorName",
          label: "Creador",
          minWidth: 200,
          // fixed: true
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "ImageCreator"
          }
        },
        {
          prop: "iterationDescription",
          label: "Descripcion",
          minWidth: 200
          // fixed: true
        },
        {
          prop: "Conclusion",
          label: "Conclusión",
          minWidth: 200
          // fixed: true
        }
      ],
      DetailData: {
        Year: 0,
        Month: 0,
        CompanyId: "TB",
        Deteals: "",
        Phaseid: 0,
        deparmentId: 32,
        SalesCode: 0
      }
    };
  },

  components: {
    RabbeyTable3,
    BusinessChart
    // CustomerServiceSellerSelector
  },

  created() {
    this.detailTableLoading = true;
    this.GetSalesSupervisor(null, 0);
    this.GetEmpleesByDeparment(32);
    this.detailTableLoading = false;
  },

  methods: {
    GetSalesSupervisor(Deteals, month) {
      this.detailTableLoading = true;
      this.$http
        .get("/api/deals/GetSalesSupervisor", {
          params: {
            CompanyId: this.Company,
            year: this.year,
            Deteals: Deteals,
            month: month,
            deparmentId: this.deparmentId,
            SalesCode: this.SalesCode
          }
        })
        .then((resp) => {
          this.items = resp.data;
        })
        .finally(() => {
          this.detailTableLoading = false;
        });
    },
    GetEmpleesByDeparment(valor) {
      this.loading = true;

      this.$http
        .get("/api/users/GetCustomerServiceSeller", {
          params: {
            DeparmentId: valor
          }
        })
        .then((response) => {
          this.customer_seller = response.data;
        })
        .catch((error) => {
          console.error(error);
        });

      this.loading = false;
    },
    GetSalesSupervisorDetails(Deteals, month) {
      this.$http
        .get("/api/deals/GetSalesSupervisorDetails", {
          params: {
            CompanyId: this.Company,
            year: this.year,
            Deteals: Deteals,
            month: this.getMonthNumber(month),
            deparmentId: this.deparmentId,
            SalesCode: this.SalesCode
          }
        })
        .then((resp) => {
          this.itemsDetails = resp.data;
          this.Ganada = 0;
          this.perdida = 0;
          this.total = 0;

          this.itemsDetails.forEach((objeto) => {
            if (objeto.PhaseId == 6) {
              this.Ganada++;
            } else {
              this.perdida++;
            }
          });
          this.total = (this.Ganada / (this.perdida + this.Ganada)) * 100 + "";
          this.total = this.total.substring(0, 5);

          this.$refs.detailChart2.getChartData();
        });
    },
    handleChangeCustomerSeller(sellerId) {
      this.seller_filter = sellerId;
      this.customers_service_seller_filter2 = sellerId;

      this.getStatsDeal();
      this.__handlePagination({ SellerId: sellerId });
      this.$refs.reportDeal.$refs.table.refreshTable();
    },
    getMonthNumber(month) {
      switch (month) {
        case "january":
          return 1;
        case "february":
          return 2;
        case "march":
          return 3;
        case "april":
          return 4;
        case "may":
          return 5;
        case "june":
          return 6;
        case "july":
          return 7;
        case "august":
          return 8;
        case "september":
          return 9;
        case "october":
          return 10;
        case "november":
          return 11;
        case "december":
          return 12;
      }
    },
    getTagType() {
      if (this.total > 70) {
        return "danger";
      } else if (this.total >= 95) {
        return "success";
      } else if (this.total >= 80 && this.total <= 95) {
        return "warning";
      }
      return "info";
    },
    OpenSalesDitails(row, label) {
      this.PhasesId = 0;
      this.Titulo = row.Titulo;
      this.ShowIndex = false;
      switch (row.Titulo) {
        case "Negociaciones":
          this.SalesColumns = this.ColumnDetailsNegociaciones;

          break;
        case "Prospectos":
          this.SalesColumns = this.columnsProspectos;

          break;
        case "Presentación":
          this.PhasesId = 2;
          this.SalesColumns = this.ColumnsPresentaciOn;
          this.Titulo = "general";

          break;
        case "Cotizaciones":
          this.PhasesId = 3;
          this.SalesColumns = this.ColumnsCotizacion;
          this.Titulo = "Cotizaciones";

          break;
        case "Citas":
          this.SalesColumns = this.agendas;
          break;
        case "Llamadas":
          this.SalesColumns = this.interacciones;
          break;
        case "Visitas":
          this.SalesColumns = this.interacciones;
          break;
        case "Ganadas":
          this.PhasesId = 6;
          this.SalesColumns = this.ColumnsPresentaciOn;
          this.Titulo = "general";
          break;
        case "Perdidas":
          this.PhasesId = 8;
          this.SalesColumns = this.ColumnsPresentaciOn;
          this.Titulo = "general";

          break;
        case "Indice de Cierre":
          this.SalesColumns = this.ColumnsPresentaciOn;
          this.Titulo = "Indice de Cierre";
          this.PhasesId = 8;
          this.ShowIndex = true;
      }
      this.DetailData = {
        Year: this.year,
        Month: this.getMonthNumber(label),
        CompanyId: this.Company,
        Deteals: this.Titulo,
        Phaseid: this.PhasesId,
        SalesCode: this.SalesCode,
        DeparmentId: this.deparmentId
      };

      this.GetSalesSupervisorDetails(row.Titulo, label);

      this.openDetail = true;
      this.Titulo = row.Titulo;
      this.Month = label;
    },
    hanldeSelection(value) {
      this.SalesCode = value;
      this.GetSalesSupervisor();
    },
    CloseTransactionDetail() {
      this.openDetail = false;
      this.Business.interactionList = [];
      this.itemsDetails = [];
      this.$refs.detailChart2.bar.series[0].data = [];
      this.$refs.detailChart2.loading = true;
    },
    async Filtropordepartamento(selectvalue) {
      this.SalesCode = null;
      this.deparmentId = selectvalue;
      this.sellerSelected = null;

      this.GetEmpleesByDeparment(selectvalue);
      this.GetSalesSupervisor();
    }
  },

  watch: {
    year() {
      this.GetSalesSupervisor();
    },
    customers_service_seller_filter2(val) {
      this.SalesCode = val;
      this.GetSalesSupervisor();
    }
  }
};
</script>

<style></style>
